import { render, staticRenderFns } from "./UnapproveModal.vue?vue&type=template&id=c0a649ba&"
import script from "./UnapproveModal.vue?vue&type=script&lang=js&"
export * from "./UnapproveModal.vue?vue&type=script&lang=js&"
import style0 from "./UnapproveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports